import NotFoundPage from "./NotFound";
import "./styles.scss";

export default { NotFoundPage };
